import ActionsList from 'cancellations/components/cancellation-underage/search/actions';
import { CancellationUnderageSearchCrumbs } from 'cancellations/constants/cancellation-underage.crumbs';
import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';
import { __PERSON_NEW_API_URL__ } from 'shell/constants/environment';

const CancellationUnderageSearchPersonPage = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={CancellationUnderageSearchCrumbs} />
      <PersonSearch
        pathname="/cancellazioni/minori/operazione"
        action={ActionsList}
        addedTitle="- Cancellazione Minore"
        url={`${__PERSON_NEW_API_URL__}/ricerca-persona/cancellazione-minore`}
        isOnlyNationalSearch
      />
    </Fragment>
  );
};

CancellationUnderageSearchPersonPage.displayName = 'Cancellation underage search component';

export default CancellationUnderageSearchPersonPage;
